<template>
  <div class="animated fadeIn">
    <b-row v-if="chkdetail">
      <b-col cols="12">
        <b-card header-bg-variant="primary">
          <div slot="header">
            <strong>MFU Service Dormitory</strong>
          </div>
          <p>{{item_group.note.en}}</p>
          <div class="bd-example">
            <dl class="row">
              <dt class="col-sm-3 col-lg-2">Student ID:</dt>
              <dd class="col-sm-9 col-lg-10">{{item_studentprofile.studentid}}</dd>

              <dt class="col-sm-3 col-lg-2">Name-Surname:</dt>
              <dd class="col-sm-9 col-lg-10">
                {{item_studentprofile.prefixname}} {{item_studentprofile.studentname}} {{item_studentprofile.studentsurname}}
              </dd>

              <dt class="col-sm-3 col-lg-2">School of:</dt>
              <dd class="col-sm-9 col-lg-10">{{item_studentprofile.facultyname}}</dd>

              <dt class="col-sm-3 col-lg-2">Program:</dt>
              <dd class="col-sm-9 col-lg-10">{{item_studentprofile.departmentname}}</dd>
            </dl>
          </div>
        </b-card>
      </b-col>

      <b-col cols="12" v-if="chkgroup===1">
        <b-card header-bg-variant="warning" v-if="item_reserv.buildid === null && chkConfirm">
          <div slot="header">
            <strong>Confirm Room Information</strong>
          </div>
          <div class="bd-example">
            <p>Check your information, room, and dormitory (If you find something wrong; go to see officer at dormitory central office as soon as possible)</p>
            <dl class="row">
              <dt class="col-sm-3 col-lg-2">Building:</dt>
              <dd class="col-sm-9 col-lg-10">{{item_reservlate.buildnameeng}}</dd>

              <dt class="col-sm-3 col-lg-2">Room:</dt>
              <dd class="col-sm-9 col-lg-10">{{item_reservlate.room}}</dd>
            </dl>
          </div>

          <div slot="footer">
            <b-button size="md" variant="warning" class="btn-md" @click="confirmData(1)">Confirm</b-button>
          </div>
        </b-card>

        <b-card header-bg-variant="success" v-if="item_reserv.buildid !== null && chkConfirm">
          <div slot="header">
            <strong>Room Information</strong>
          </div>

          <div class="bd-example">
            <p>Check your information, room, and dormitory (If you find something wrong; go to see officer at dormitory central office as soon as possible)</p>
            <dl class="row">
              <dt class="col-sm-3 col-lg-2">Building:</dt>
              <dd class="col-sm-9 col-lg-10">{{item_reserv.buildnameeng}}</dd>

              <dt class="col-sm-3 col-lg-2">Room:</dt>
              <dd class="col-sm-9 col-lg-10">{{item_reserv.room}}</dd>

              <dt class="col-sm-3 col-lg-2">Max Person:</dt>
              <dd class="col-sm-9 col-lg-10">{{item_reserv.maxroom}} Person</dd>

              <dt class="col-sm-3 col-lg-2">Price:</dt>
              <dd class="col-sm-9 col-lg-10">{{item_reserv.price}} Baht/Person</dd>

              <dt class="col-sm-3 col-lg-2">Status:</dt>
              <dd class="col-sm-9 col-lg-10 text-danger" v-if="item_reserv.paystatus === 0">
                <b>{{item_reserv.paynote}}</b>
              </dd>
              <dd class="col-sm-9 col-lg-10 text-success" v-if="item_reserv.paystatus === 1">
                <b>{{item_reserv.paynote}}</b>
              </dd>
            </dl>

            <hr>

            <dl class="row">
              <dt class="col-sm-3 col-lg-2">Roommate:</dt>
              <dd class="col-sm-9 col-lg-10">
                <ul class="roommate">
                  <li v-for="item in item_reserv.roommate" v-bind:key="item.studentid">
                    - {{ item.prefixname }} {{ item.studentname }} {{ item.studentsurname }} {{ item.facultyname }} {{ item.departmentname }}
                  </li>
                </ul>
              </dd>
            </dl>

            <b-alert show variant="warning" v-if="loadingPrint">Loading Print Invoice...</b-alert>
          </div>

          <div slot="footer" v-if="item_reserv.paystatus === 0">
            <b-button size="md" variant="success" class="btn-md" v-if="item_group.invoice" @click="printInvoice">
              <i class="fa fa-print"></i> Print Invoice
            </b-button>
          </div>
        </b-card>
      </b-col>

      <b-col cols="12" v-if="chkgroup===2 || chkgroup===33">
        <b-card header-bg-variant="warning" v-if="item_reserv.buildid === null && chkConfirm">
          <div slot="header">
            <strong>Select Option Dorm</strong>
          </div>
          <div class="bd-example">
            <b-form-group
                description="Select dormitory"
                label="Select Building :"
                label-for="LODGEID"
                :label-cols="3"
                :horizontal="true"
              >
                <b-form-select
                  v-model="getdata.building.selected"
                  id="LODGEID"
                  @change="GetAllBuildings()"
                >
                  <option v-for="option in getdata.building.options" v-bind:value="option.value"  v-bind:key="option.value">{{ option.text }}</option>
                </b-form-select>
              </b-form-group>

              <b-form-group
                description="Select dormitory"
                label="Select Building :"
                label-for="LODGEIDTYPE"
                :label-cols="3"
                :horizontal="true"
              >
                <b-form-select
                  v-model="getdata.buildingtype.selected"
                  id="LODGEIDTYPE"
                  @change="GetAllBuildings()"
                >
                  <option
                    v-for="option in getdata.buildingtype.options"
                    v-bind:value="option.value" v-bind:key="option.value"
                  >{{ option.text }}</option>
                </b-form-select>
              </b-form-group>

              <b-row>
                <b-col cols="12" v-if="chkdetail_building">
                  <b-alert show variant="warning" >Data not found....</b-alert>
                </b-col>
                

                <b-col sm="12" lg="6" v-for="(item_main) in item_building.buildings" v-bind:key="item_main.id">
                  <b-card header-bg-variant="warning">
                    <div slot="header">
                      <strong>{{item_main.nameeng}}</strong>
                    </div>
                    <b-row>
                      <b-col v-for="(item_floor) in item_main.floors" cols="12" v-bind:key="item_floor.id">
                         <table class="table table-bordered">
                          <thead class="thead-light">
                            <tr>
                              <th scope="col" class="text-center">Floors: {{item_floor.id}}</th>
                              <th scope="col" class="text-center">Booking</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(item_rooms) in item_floor.rooms"  v-bind:key="item_rooms.id">
                              <td >{{item_rooms.name}}</td>
                              <td>
                                <b-button size="md" variant="success" class="btn-md btn-block" v-if="item_rooms.status" @click="selectRoomData(item_main.id,item_rooms.id)">
                                  Booking
                                </b-button>

                                <b-button Disabled="true" size="md" variant="secondary" class="btn-md btn-block" v-else>
                                  Booking
                                </b-button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </b-col>
                    </b-row>
                    
                  </b-card>
                </b-col>

              </b-row>

              <!--<b-button size="md" variant="success" class="btn-md btn-block" @click="GetAllBuildings">
                Search
              </b-button> -->
          </div>
        </b-card>

        <b-card header-bg-variant="warning" v-if="item_reserv.buildid === null && !chkConfirm">
          <div slot="header">
            <strong>Room Information</strong>
          </div>
          <div class="bd-example">
            <p>Check your information, room, and dormitory (If you find something wrong; go to see officer at dormitory central office as soon as possible)</p>
            <dl class="row">
              <dt class="col-sm-3 col-lg-2">Building:</dt>
              <dd class="col-sm-9 col-lg-10">{{item_reserv_confirmroom.buildnameeng}}</dd>

              <dt class="col-sm-3 col-lg-2">Room:</dt>
              <dd class="col-sm-9 col-lg-10">{{item_reserv_confirmroom.room}}</dd>

              <dt class="col-sm-3 col-lg-2">Max Person:</dt>
              <dd class="col-sm-9 col-lg-10">{{item_reserv_confirmroom.maxroom}}</dd>

              <dt class="col-sm-3 col-lg-2">Price:</dt>
              <dd class="col-sm-9 col-lg-10">{{item_reserv_confirmroom.price}}</dd>

            </dl>

            <hr>

            <dl class="row">
              <dt class="col-sm-3 col-lg-2">Roommate:</dt>
              <dd class="col-sm-9 col-lg-10">
                <ul class="roommate">
                  <li v-for="item in item_reserv_confirmroom.roommate" v-bind:key="item.studentid">
                    - {{ item.prefixname }} {{ item.studentname }} {{ item.studentsurname }} {{ item.facultyname }} {{ item.departmentname }}
                  </li>
                </ul>
              </dd>
            </dl>
          </div>

          <div slot="footer">
            <b-button size="md" variant="warning" class="btn-md" @click="confirmData(2)">Confirm</b-button>&nbsp;
            <b-button size="md" variant="secondary" class="btn-md" @click="resetPage()">Cancel</b-button>
          </div>
        </b-card>

        <b-card header-bg-variant="success" v-if="item_reserv.buildid !== null && chkConfirm">
          <div slot="header">
            <strong>Room Information</strong>
          </div>

          <div class="bd-example">
            <p>Check your information, room, and dormitory (If you find something wrong; go to see officer at dormitory central office as soon as possible)</p>
            <dl class="row">
              <dt class="col-sm-3 col-lg-2">Building:</dt>
              <dd class="col-sm-9 col-lg-10">{{item_reserv.buildnameeng}}</dd>

              <dt class="col-sm-3 col-lg-2">Room:</dt>
              <dd class="col-sm-9 col-lg-10">{{item_reserv.room}}</dd>

              <dt class="col-sm-3 col-lg-2">Max Person:</dt>
              <dd class="col-sm-9 col-lg-10">{{item_reserv.maxroom}} Person</dd>

              <dt class="col-sm-3 col-lg-2">Price:</dt>
              <dd class="col-sm-9 col-lg-10">{{item_reserv.price}} Baht/Person</dd>

              <dt class="col-sm-3 col-lg-2">Status:</dt>
              <dd class="col-sm-9 col-lg-10 text-danger" v-if="item_reserv.paystatus === 0">
                <b>{{item_reserv.paynote}}</b>
              </dd>
              <dd class="col-sm-9 col-lg-10 text-success" v-if="item_reserv.paystatus === 1">
                <b>{{item_reserv.paynote}}</b>
              </dd>
            </dl>

            <hr>

            <dl class="row">
              <dt class="col-sm-3 col-lg-2">Roommate:</dt>
              <dd class="col-sm-9 col-lg-10">
                <table class="table table-bordered">
                  <tr>
                    <th>Name - Surname</th>
                    <th>School</th>
                    <th>Program</th>
                  </tr>
                  <tr v-for="item in item_reserv.roommate" v-bind:key="item.studentid">
                    <td>{{ item.prefixname }} {{ item.studentname }} {{ item.studentsurname }}</td>
                    <td>{{ item.facultyname }}</td>
                    <td>{{ item.departmentname }}</td>
                  </tr>
                </table>
              </dd>
            </dl>

            <b-alert show variant="warning" v-if="loadingPrint">Loading Print Invoice...</b-alert>
          </div>

          <div slot="footer" v-if="item_reserv.paystatus === 0">
            <b-button size="md" variant="success" class="btn-md" v-if="item_group.invoice" @click="printInvoice">
              <i class="fa fa-print"></i> Print Invoice
            </b-button>
          </div>
        </b-card>
      </b-col>

      <b-col cols="12" v-if="chkgroup===31">
        <b-card header-bg-variant="warning" v-if="item_register.id === null && chkConfirm">
          <div slot="header">
            <strong>Confirm Register Dormitory</strong>
          </div>
          <div class="bd-example">
            <p>Check your information and click "Confirm Register" (If you find something wrong; go to see officer at dormitory central office as soon as possible)</p>
          </div>
          <div slot="footer">
            <b-button size="md" variant="warning" class="btn-md" @click="confirmData(1)">Confirm</b-button>
          </div>
        </b-card>

        <b-card header-bg-variant="success" v-if="item_register.id !== null && chkConfirm">
          <div slot="header">
            <strong>Status Register Dormitory</strong>
          </div>
          <div class="bd-example">
            <p>When student finished confirm registration website will show that student already registered.The qualified students name list will be announce the week after.</p>
            <hr/>
            <dl class="row">
              <dt class="col-sm-3 col-lg-2">Status:</dt>
              <dd class="col-sm-9 col-lg-10">{{item_register.statusnote}}</dd>
            </dl>
          </div>
        </b-card>
      </b-col>

      <b-col cols="12" v-if="chkgroup===32">
        <b-card header-bg-variant="success" v-if="item_register.id !== null && chkConfirm">
          <div slot="header">
            <strong>Status Register Dormitory</strong>
          </div>
          <div class="bd-example">
            <p>When student finished confirm registration website will show that student already registered.The qualified students name list will be announce the week after.</p>
            <hr/>
            <dl class="row">
              <dt class="col-sm-3 col-lg-2">Status:</dt>
              <dd class="col-sm-9 col-lg-10">{{item_register.statusnote}}</dd>
            </dl>
          </div>
        </b-card>
      </b-col>

    </b-row>

    <b-row v-if="!chkdetail">
      <b-col cols="12">
        <b-card>
          <div slot="header">
            <strong>MFU Service Dormitory</strong>
          </div>
          <p>{{chkdetail_message}}</p>
        </b-card>
      </b-col>
    </b-row>

    <!--<b-row v-if="chkgroup===2">
      <b-col cols="12">กลุ่ม 2</b-col>
    </b-row>

    <b-row v-if="chkgroup===31">
      <b-col cols="12">กลุ่ม 31</b-col>
    </b-row>

    <b-row v-if="chkgroup===32">
      <b-col cols="12">กลุ่ม 32</b-col>
    </b-row>

    <b-row v-if="chkgroup===33">
      <b-col cols="12">กลุ่ม 33</b-col>
    </b-row>-->
  </div>
</template>

<script>
import AuthenService from "@/services/AuthenService";
import YearService from "@/services/YearService";
import BookingService from "@/services/BookingService";
import store from "@/store/store";

import Api from "@/services/Api";
const dormpath = "studentdev/dormitory/";

import pdf from 'vue-pdf'

export default {
  name: "Dashboard",
  data: () => ({
    chkdetail: false,
    chkdetail_message: null,
    chkdetail_building: false,
    chkgroup: 0,
    chkConfirm: false,
    chkConfirmRoom: false,
    loadingPrint : false,
    loadingBuilding : false,
    item_voice : null,
    items_data: [],
    item_group: [],
    item_register: [],
    item_reserv: [],
    item_reservlate: [],
    item_studentprofile: [],
    item_building: [],
    item_reserv_confirmroom : [],
    errors: [],
    getdata : {
      buildingtype: {
        selected: "0",
        options :[]
      },
      building: {
        selected: "0",
        options :[]
      },
    }
  }),
  mounted: function() {
    this.CheckToken(); //method1 will execute at pageload
    this.CheckGroup();
    //this.GetDetail();
  },
  methods: {
    async CheckGroup() {
      //************************************************ */
      this.chkgroup = 0;
      //************************************************ */
      await Api()
        .get(dormpath + "check/group/service")
        .then(response => {
          var data = response.data;
          this.item_group = data.data;
          this.chkgroup = this.item_group.groupid;
          this.chkdetail = true;
          

          this.GetDetail();
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$router.push("/pages/login");
          } else if (error.response.status == 404) {
            this.chkdetail_message = error.response.data.message.en;
          }
          else{
             this.chkdetail_message = "Reservation system is closed.";
          }

          this.chkdetail = false;
        });
      //************************************************ */
    },
    async GetDetail() {
      //************************************************ */
      this.item_register = [];
      this.item_reserv = [];
      this.item_reservlate = [];
      this.item_studentprofile = [];
      //************************************************ */
      //console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxx');
      await Api()
        .get(dormpath + "booking/register")
        .then(response => {
          this.item_register = response.data.data.register;
          this.item_reserv = response.data.data.reserv;
          this.item_reservlate = response.data.data.reservlate;
          this.item_studentprofile = response.data.data.studentprofile;

          this.chkConfirm = true;

          if(((this.chkgroup == 2) || (this.chkgroup == 33)) && this.item_reserv.buildid === null) {
            //console.log('yyyy');
            //************************************************ */
            this.GetListBuildings();
            //************************************************ */
            this.GetListPersons();
            //************************************************ */
            //await this.GetAllBuildings();
            //************************************************ */
          }
        })
        .catch(error => {
          console.log(error.response.data);
        });
    },
    async GetListBuildings(){
      await Api()
        .get(dormpath + "buildings")
        .then(response => {
         for (let i = 0; i < response.data.data.length; i++) {
            this.getdata.building.options.push({
               text: response.data.data[i].name, value: response.data.data[i].id
            });
          }
      }),500
    },
    async GetListPersons(){
      await Api()
        .get(dormpath + "persons")
        .then(response => {
         for (let i = 0; i < response.data.data.length; i++) {
            this.getdata.buildingtype.options.push({
               text: response.data.data[i].name, value: response.data.data[i].id
            });
          }
      }),500
    },
    async GetAllBuildings(){
      //************************************************ */
      let buildingtype = this.getdata.buildingtype.selected;
      let building = this.getdata.building.selected;
      let url = "?bid=" + building + "&pid=" + buildingtype;
      
      //************************************************ */
      if(buildingtype == 0){buildingtype = null;}
      if(building == 0){building = null;}

      //console.log(url);
      //************************************************ */
      this.chkdetail_building = false;
      //************************************************ */
      await Api()
            .get(dormpath + "booking/buildings" + url)
            .then(response => {
              this.item_building = response.data.data;
              //console.log(this.item_building);
            })
            .catch(error => {
              this.item_building = [];
              this.chkdetail_building = true;
              //console.log(error.response.data);
            }),500;   
      //************************************************ */
    },
    async CheckToken() {
      if (!store.state.token) {
        this.$router.push("/pages/login");
      } else {
        //console.log(store.state.token);
      }
    },
    async confirmData(gid) {
      var r = confirm("Confirm Room Information?");
      if (r) {
        if (gid == 1) {
          await Api()
            .post(dormpath + "booking/register")
            .then(response => {
              this.resetPage();
              //this.GetDetail();
            })
            .catch(error => {
              this.chkdetail = false;
              this.chkdetail_message = error.response.data.message.en;
            });
        }
        else if (gid == 2) {
          this.items_data = {
                              builingid: this.item_reserv_confirmroom.buildid,
                              room: this.item_reserv_confirmroom.room,
                            }
          await Api()
            .post(dormpath + "booking/register",this.items_data)
            .then(response => {
              this.resetPage();
            })
            .catch(error => {
              this.chkdetail = false;
              this.chkdetail_message = error.response.data.message.en;
            });
          //console.log(this.items_data);
        }
      }
    },
    async printInvoice(){
      //************************************************ */
      this.loadingPrint = true;
      await Api()
            .get(dormpath + "booking/invoice")
            .then(response => {
              //************************************************ */
              this.item_voice = null;
              this.item_voice = response.data;
              //************************************************ */
              this.loadingPrint = false;
              //************************************************ */
              const linkSource = "data:application/pdf;base64," + this.item_voice;
              const downloadLink = document.createElement("a");
              const fileName = "invoice.pdf";
              //************************************************ */
              downloadLink.href = linkSource;
              downloadLink.download = fileName;
              downloadLink.click();
            })
            .catch(error => {
              this.chkdetail_message = error.response.data.message.en;
              this.chkdetail = false;
            });
      //************************************************ */
    },
    async selectRoomData(bid,rid){
      //console.log(bid);
      //console.log(rid);
      this.chkConfirm = false;
      this.chkConfirmRoom = true;
      let url = "?bid=" + bid + "&rid=" + rid;
      //********************************************* */
      this.item_reserv_confirmroom = [];
      //********************************************* */
      await Api()
            .get(dormpath + "booking/buildings/price" + url)
            .then(response => {
              this.item_reserv_confirmroom = response.data.data.reserv;
              //console.log(this.item_building);
            })
            .catch(error => {
              this.item_reserv_confirmroom = [];
            }),500;   
    },
    async resetPage(){
      location.reload();
    }
  }
};
</script>

<style>
ul.roommate {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
</style>